// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanHeader.yaml
// Generated: 2026-06-02T14:10:11.393Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePlanHeader, UpdatePlanHeader, PlanHeader } from '@/types/finance/PlanHeader';

/**
 * PlanHeader Service
 * CRUD operations for PlanHeader via the ABP API.
 */
export const planHeaderService = new EntityService<PlanHeader, CreatePlanHeader, UpdatePlanHeader>(
  '/api/finance/planheader',
  'PlanHeader',
);
